/** @internal */
const DecodeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Encoding/errors/Decode");

/** @internal */
const DecodeException = (input, message) => ({
  _tag: "DecodeException",
  [DecodeExceptionTypeId]: DecodeExceptionTypeId,
  input,
  message
});

/** @internal */
const isDecodeException = u => typeof u === "object" && u != null && DecodeExceptionTypeId in u;

/** @interal */
const encoder = /*#__PURE__*/new TextEncoder();

/** @interal */
const decoder = /*#__PURE__*/new TextDecoder();

export { DecodeException, DecodeExceptionTypeId, decoder, encoder, isDecodeException };
